/**
 * Fetches a logic wrapper collection from the CMS based on a delivery key.
 *
 * This composable retrieves a collection of logic wrappers using the provided
 * delivery key, current locale, and optional query parameters.
 *
 * @param {string} deliveryKey - The key used to identify the specific logic wrapper collection
 * @returns {Promise<FetchResult>} A promise resolving to the fetched logic wrapper collection
 *
 * @example
 * const { data } = await useLogicWrapperCollection('homePageWrappers')
 * console.log(data.value.collection) // Displays the logic wrapper collection
 */
export async function useLogicWrapperCollection(deliveryKey: string) {
  const localePath = useLocalePath()

  const query = {
    locale: localePath(''),
    vse: useRoute().query.vse,
    contentId: useRoute().query.contentId,
    deliveryKey: deliveryKey,
  }

  return useFetch('/api/cms/getLogicWrapperCollection', {
    query,
  })
}
